module.exports = __webpack_public_path__ + "static/media/arrow-left.fd27b8ae.svg";